import { render } from "./SkillsPopup.vue?vue&type=template&id=541a1864"
import script from "./SkillsPopup.vue?vue&type=script&lang=js"
export * from "./SkillsPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__